function handleParallax() {
  // パララックス要素を取得
  const parallaxBg = document.querySelector('.bns-brand-modal-bg');

  if (parallaxBg) {
    // ウィンドウのスクロール位置を取得
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    // 要素の画面内での位置を取得 (getBoundingClientRect().top は、ビューポート上端からの距離)
    const elementRect = parallaxBg.getBoundingClientRect();
    const elementTopInView = elementRect.top + scrollTop;
    const elementBottomInView = elementTopInView + elementRect.height;
    
    // ウィンドウの高さ
    const windowHeight = window.innerHeight;

    // 要素が画面内に完全に入った位置からのスクロール量を計算
    // この計算は、スクロールに合わせて背景をどれだけ動かすかを制御します
    // ここでは、要素が画面下部から入ってきて、画面上部へ出るまでの間のスクロール量を計算しています
    const scrollPercent = (scrollTop + windowHeight - elementTopInView) / (windowHeight + elementRect.height);

    // アニメーション範囲を定義: 0px から -400px まで動かしたい
    const startY = 0;
    const endY = -400;
    
    // 現在の背景のY位置を計算
    // scrollPercent は 0から1の間で変化します
    const currentY = startY + (endY - startY) * scrollPercent;
    
    // 背景位置を設定
    // CSS変数を使って設定すると、JavaScriptからの操作が容易になります
    parallaxBg.style.backgroundPosition = `center ${currentY}px`;
    
    // または transform を使って要素自体を動かすことも可能
    // parallaxBg.style.transform = `translateY(${currentY}px)`;
  }
}

// スクロールとリサイズイベントにリスナーを追加
window.addEventListener('scroll', handleParallax);
window.addEventListener('resize', handleParallax);

// 初回読み込み時にも実行して位置を合わせる
document.addEventListener('DOMContentLoaded', handleParallax);
// Shopifyでは window の load イベントの方が確実な場合もあります
window.addEventListener('load', handleParallax);